import { memo } from 'react';
import NotificationChannels from './NotificationChannels';
import SubscribedCompanies from './SubscribedCompanies';

const SubscriptionsTab = memo(() => {
    return (
    <>
        <NotificationChannels />
        <SubscribedCompanies />
    </>
    );
});

export default SubscriptionsTab;
